import { observable, makeObservable } from 'mobx';
import { useStores } from '../useStores';
import withActions from '../withActions';
import actions from './actions';

export default class ProfileStore {
    version = '1.0';
    profile = null;
    profileDisplay = {};  // derived display-ready values — built in getProfile action
    collections = [];     // first 4 active subscriptions, flattened — built in getSubscriptions action
    devices = [];
    observed = {};

    constructor() {
        makeObservable(this, { observed: observable });
        withActions(this, actions);
    }
}

export function useProfileStore() {
    const { store } = useStores();
    return store.profileStore;
}
